import { BasicSettings, Password } from './blocks';

const UserSettingsContent = () => {
  return (
    <div className="grid gap-5 lg:gap-7.5 xl:w-[38.75rem] mx-auto">
      <BasicSettings title="General Settings" />

      <Password title="Password" />

        {/*<DeleteAccount />*/}
    </div>
  );
};

export { UserSettingsContent };
